import { Video, VideoOff, Mic, MicOff, Radio, StopCircle } from 'lucide-react';

export function VideoPreview({ videoRef, localStream, isStreaming }) {
  return (
    <div className="aspect-video bg-black rounded-lg overflow-hidden mb-4 relative">
      <video
        ref={videoRef}
        autoPlay
        muted
        playsInline
        className="w-full h-full object-cover"
      />
      {!isStreaming && !localStream && (
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center">
            <Video className="w-16 h-16 text-gray-500 mx-auto mb-4" />
            <p className="text-gray-400">Preview will appear here</p>
          </div>
        </div>
      )}
    </div>
  );
}

export function StreamControls({ 
  isStreaming, 
  videoEnabled, 
  audioEnabled, 
  onToggleVideo, 
  onToggleAudio, 
  onStartStream, 
  onStopStream 
}) {
  return (
    <div className="flex items-center justify-center gap-4">
      <button
        onClick={onToggleVideo}
        disabled={!isStreaming}
        className={`p-4 rounded-full transition-all ${
          videoEnabled ? 'bg-white/10 hover:bg-white/20' : 'bg-red-500/20 text-red-400'
        } ${!isStreaming && 'opacity-50 cursor-not-allowed'}`}
        title={videoEnabled ? 'Turn off camera' : 'Turn on camera'}
        data-testid="toggle-video-btn"
      >
        {videoEnabled ? <Video className="w-6 h-6" /> : <VideoOff className="w-6 h-6" />}
      </button>
      
      <button
        onClick={onToggleAudio}
        disabled={!isStreaming}
        className={`p-4 rounded-full transition-all ${
          audioEnabled ? 'bg-white/10 hover:bg-white/20' : 'bg-red-500/20 text-red-400'
        } ${!isStreaming && 'opacity-50 cursor-not-allowed'}`}
        title={audioEnabled ? 'Mute' : 'Unmute'}
        data-testid="toggle-audio-btn"
      >
        {audioEnabled ? <Mic className="w-6 h-6" /> : <MicOff className="w-6 h-6" />}
      </button>
      
      {isStreaming ? (
        <button
          onClick={onStopStream}
          className="px-8 py-4 rounded-full bg-red-500 hover:bg-red-600 font-bold flex items-center gap-2 transition-all"
          data-testid="stop-stream-btn"
        >
          <StopCircle className="w-6 h-6" /> End Stream
        </button>
      ) : (
        <button
          onClick={onStartStream}
          className="px-8 py-4 rounded-full bg-gradient-to-r from-red-500 to-pink-500 hover:opacity-90 font-bold flex items-center gap-2 transition-all"
          data-testid="start-stream-btn"
        >
          <Radio className="w-6 h-6" /> Go Live
        </button>
      )}
    </div>
  );
}
